import React, { Dispatch, SetStateAction } from "react";
import ComplaintTable from "./ComplaintsTable";
import { IComplaint } from "../../exports/interfaces";

const ComplaintsList = ({
  complaint,
  setComplaint,
}: {
  complaint: IComplaint[];
  setComplaint: Dispatch<SetStateAction<IComplaint[]>>;
}) => {
  const urgentCount = complaint.filter((n) => n.status === "Urgent").length;

  const notUrgentCount = complaint.filter(
    (n) => n.status === "Not Urgent",
  ).length;
  const regularCount = complaint.filter((n) => n.status === "Regular").length;
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3>Complaints List</h3>
          <small>
            {urgentCount} URGENT, {regularCount} REGULAR, {notUrgentCount} NOT
            URGENT
          </small>
        </div>
      </div>
      <ComplaintTable
        viewAll={true}
        complaint={complaint}
        setComplaint={setComplaint}
      />
    </>
  );
};

export default ComplaintsList;
